import { useEffect, useRef, useState } from "react";
import ICONS from "../../../../assets/Icons";
import Loader from "../../../../components/Loader/Index";
import AssociatedAccountCard from "../../../../components/_utils/AccountCreationComponents/AssociatedAccountCard";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonToast from "../../../../components/_utils/CommonToast";

const AssociateAccountEdit = ({
  ActiveData,
  DeactiveData,
  haveAcheived,
  haveDennied,
  haveBlock,
  haveRejected,
  isApprovedState,
  haveApproved,
  havePending,
  isActive,
  activeTab,
  slideDirection,
  setSlideDirection,
  previousId,
  addSpacesToNumber,
  details,
  verifiedPan,
  beneLookLoading,
  type,
  setAccountId,
  setAccoutDetails,
}) => {
  const isFirstRender = useRef(true);
  const [animate, setAnimate] = useState(false);
  const [prevTab, setPrevTab] = useState("Active");

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setAnimate(true);
    if (prevTab === "Active" && activeTab === "Inactive") {
      setSlideDirection("right");
    } else if (prevTab === "Inactive" && activeTab === "Active") {
      setSlideDirection("left");
    }

    setPrevTab(activeTab);
  }, [activeTab]);

  const detailNavigate = (id) => {
    if (type === "field_force") {
      CommonToast({
        text: "Feature coming soon",
        icon: ICONS?.INFO_FILLED,
        variant: "var(--coming-soon)",
        buttonNeeded: false,
      });
    } else {
      setAccountId(id);
      setAccoutDetails(true);
    }
  };

  return (
    <>
      <div
        className={`py-padding-md px-padding-md bg-primary-card flex flex-col rounded-border-radius-md relative z-z-index-base ${details ? " h-auto" : "h-associated-popup-height"}`}
      >
        <style>
          {`
          @keyframes slideInFromRight {
            from {
              transform: translateX(100%);
              opacity: var(--opacity-none);
            }
            to {
              transform: translateX(0);
              opacity: var(--base-opacity);
            }
          }

          @keyframes slideInFromLeft {
            from {
              transform: translateX(-100%);
              opacity: var(--opacity-none);
            }
            to {
              transform: translateX(0);
              opacity: var(--base-opacity);
            }
          }

          .animate-slideInFromRight {
            animation: slideInFromRight var(--animation-fast-s) ease-in-out forwards;
          }

          .animate-slideInFromLeft {
            animation: slideInFromLeft var(--animation-fast-s) ease-in-out forwards;
          }
        `}
        </style>

        <div className="pr-padding-md">
          <p className="text-font-md text-text-primary font-semibold">
            Associated Accounts
          </p>
        </div>

        {details ? (
          <>
            <div className="mt-margin-sm">
              <p className="text-text-primary text-font-sm font-semibold">
                No associated accounts found
              </p>
              <p className="text-text-secondary text-font-xs font-normal">
                There are no existing accounts that are associated with the PAN
                provided.
              </p>
            </div>
          </>
        ) : (
          <>
            <div className=" mr-margin-md">
              <p className="text-font-xs text-text-secondary font-normal mt-margin-xs">
                The following existing accounts are associated with the PAN
                provided.
              </p>
            </div>
            {!beneLookLoading && verifiedPan === true ? (
              <>
                <div className="mt-margin-md pb-padding-sm">
                  <SwitcherTabs
                    tabs={[
                      { label: "Active", key: "Active", handler: ActiveData },
                      {
                        label: "Inactive",
                        key: "Inactive",
                        handler: DeactiveData,
                      },
                    ]}
                    swicherTabBgColor={"var(--primary-nav"}
                    initialActiveTab={"Active"}
                  />
                </div>
                <div className="relative overflow-hidden flex-1 overflow-y-auto">
                  <div
                    key={activeTab}
                    className={`absolute inset-0 transition-transform duration-animation-fast ease-in-out ${
                      animate
                        ? slideDirection === "right"
                          ? "animate-slideInFromRight"
                          : "animate-slideInFromLeft"
                        : ""
                    } `}
                  >
                    {activeTab === "Inactive" ? (
                      <div>
                        {haveAcheived ||
                        haveDennied ||
                        haveBlock ||
                        haveRejected ? (
                          <>
                            {(haveDennied || haveRejected) && (
                              <div>
                                <div className="my-margin-sm">
                                  <p className="text-font-xs text-text-primary font-normal">
                                    Rejected accounts
                                  </p>
                                </div>

                                <div className=" flex flex-col gap-gap-sm">
                                  {isApprovedState?.map((val, i) => {
                                    if (
                                      val?.approval_status === "rejected" ||
                                      val?.approval_status === "denied"
                                    ) {
                                      return (
                                        <div className=" mr-margin-md">
                                          <AssociatedAccountCard
                                            key={i}
                                            TitleName={val?.name}
                                            SubTitleName={` ${addSpacesToNumber(val?.bank_acc_no)} - Bank A/C number`}
                                            TitleNameColour={
                                              (val?.approval_status ===
                                                "rejected" ||
                                                val?.approval_status ===
                                                  "denied") &&
                                              "failed"
                                            }
                                            pointerEvent={
                                              previousId === val?.id
                                                ? "none"
                                                : "auto"
                                            }
                                            TitleAccountTextSize="font-md"
                                            TitleAccountFontWeight="normal"
                                            SubTitleNameColour="text-secondary"
                                            SubTitleAccountTextSize="font-xs"
                                            SubTitleAccountFontWeight="normal"
                                            RightDivIcon={ICONS?.VIEW_DETAILS}
                                            FirstDivIcon={val?.ifsc_code}
                                            CardOpacity={
                                              previousId === val?.id
                                                ? "var(--light-opacity)"
                                                : "var(--base-opacity)"
                                            }
                                            viewdetailsData={() => {
                                              detailNavigate(val?.id);
                                            }}
                                            bankLogo={true}
                                          />
                                        </div>
                                      );
                                    }
                                  })}
                                </div>
                              </div>
                            )}
                            {haveBlock && (
                              <div>
                                <div className="my-margin-sm">
                                  <p className="text-font-xs text-text-primary font-normal">
                                    Blocked accounts
                                  </p>
                                </div>
                                <div className=" flex flex-col gap-gap-sm">
                                  {isApprovedState?.map((val, i) => {
                                    if (val?.approval_status === "blocked") {
                                      return (
                                        <div className=" mr-margin-md">
                                          <AssociatedAccountCard
                                            key={i}
                                            TitleName={val?.name}
                                            SubTitleName={` ${addSpacesToNumber(val?.bank_acc_no)} - Bank A/C number`}
                                            TitleNameColour={
                                              val?.approval_status ===
                                                "blocked" && "failed"
                                            }
                                            CardOpacity={
                                              previousId === val?.id
                                                ? "var(--light-opacity)"
                                                : "var(--base-opacity)"
                                            }
                                            pointerEvent={
                                              previousId === val?.id
                                                ? "none"
                                                : "auto"
                                            }
                                            TitleAccountTextSize="font-md"
                                            TitleAccountFontWeight="normal"
                                            SubTitleNameColour="text-secondary"
                                            SubTitleAccountTextSize="font-xs"
                                            SubTitleAccountFontWeight="normal"
                                            RightDivIcon={ICONS?.VIEW_DETAILS}
                                            FirstDivIcon={val?.ifsc_code}
                                            viewdetailsData={() => {
                                              detailNavigate(val?.id);
                                            }}
                                            bankLogo={true}
                                          />
                                        </div>
                                      );
                                    }
                                  })}
                                </div>
                              </div>
                            )}
                            {haveAcheived && (
                              <div>
                                <div className="my-margin-sm">
                                  <p className="text-font-xs text-text-primary font-normal">
                                    Archived accounts
                                  </p>
                                </div>

                                <div className=" flex flex-col gap-gap-sm">
                                  {isApprovedState?.map((val, i) => {
                                    if (val?.approval_status === "archived") {
                                      return (
                                        <div className=" mr-margin-md">
                                          <AssociatedAccountCard
                                            key={i}
                                            TitleName={val?.name}
                                            SubTitleName={` ${addSpacesToNumber(val?.bank_acc_no)} - Bank A/C number`}
                                            TitleNameColour={
                                              val?.approval_status ===
                                                "archived" && "abandoned"
                                            }
                                            CardOpacity={
                                              previousId === val?.id
                                                ? "var(--light-opacity)"
                                                : "var(--base-opacity)"
                                            }
                                            pointerEvent={
                                              previousId === val?.id
                                                ? "none"
                                                : "auto"
                                            }
                                            TitleAccountTextSize="font-md"
                                            TitleAccountFontWeight="normal"
                                            SubTitleNameColour="text-secondary"
                                            SubTitleAccountTextSize="font-xs"
                                            SubTitleAccountFontWeight="normal"
                                            RightDivIcon={ICONS?.VIEW_DETAILS}
                                            FirstDivIcon={val?.ifsc_code}
                                            viewdetailsData={() => {
                                              detailNavigate(val?.id);
                                            }}
                                            bankLogo={true}
                                          />
                                        </div>
                                      );
                                    }
                                  })}
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="mt-margin-md">
                            <p className="text-text-primary text-font-sm font-semibold">
                              No inactive associated accounts found
                            </p>
                            <p className="text-text-secondary text-font-xs font-normal">
                              There are no existing inactive accounts that are
                              associated with the PAN provided.
                            </p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        {haveApproved || havePending ? (
                          <>
                            {haveApproved && (
                              <div>
                                <div className="my-margin-sm">
                                  <p className="text-font-xs text-text-primary font-normal">
                                    Approved accounts
                                  </p>
                                </div>
                                <div className=" flex flex-col gap-gap-sm">
                                  {isApprovedState?.map((val, i) => {
                                    if (val?.approval_status === "approved") {
                                      return (
                                        <div className=" mr-margin-md ">
                                          <AssociatedAccountCard
                                            key={i}
                                            TitleName={val?.name}
                                            SubTitleName={` ${addSpacesToNumber(val?.bank_acc_no)} - Bank A/C number`}
                                            TitleNameColour={"settled"}
                                            CardOpacity={
                                              previousId === val?.id
                                                ? "var(--light-opacity)"
                                                : "var(--base-opacity)"
                                            }
                                            pointerEvent={
                                              previousId === val?.id
                                                ? "none"
                                                : "auto"
                                            }
                                            TitleAccountTextSize="font-md"
                                            TitleAccountFontWeight="normal"
                                            SubTitleNameColour="text-secondary"
                                            SubTitleAccountTextSize="font-xs"
                                            SubTitleAccountFontWeight="normal"
                                            RightDivIcon={ICONS?.VIEW_DETAILS}
                                            FirstDivIcon={val?.ifsc_code}
                                            viewdetailsData={() => {
                                              detailNavigate(val?.id);
                                            }}
                                            bankLogo={true}
                                          />
                                        </div>
                                      );
                                    }
                                  })}
                                </div>
                              </div>
                            )}
                            {havePending && (
                              <div>
                                <div className="my-margin-sm">
                                  <p className="text-font-xs text-text-primary font-normal">
                                    Pending accounts
                                  </p>
                                </div>
                                <div className=" flex flex-col gap-gap-sm">
                                  {isApprovedState?.map((val, i) => {
                                    if (val?.approval_status === "pending") {
                                      return (
                                        <div className=" mr-margin-md">
                                          <AssociatedAccountCard
                                            key={i}
                                            TitleName={val?.name}
                                            SubTitleName={` ${addSpacesToNumber(val?.bank_acc_no)} - Bank A/C number`}
                                            TitleNameColour={
                                              val?.approval_status ===
                                                "pending" && "pending"
                                            }
                                            CardOpacity={
                                              previousId === val?.id
                                                ? "var(--light-opacity)"
                                                : "var(--base-opacity)"
                                            }
                                            pointerEvent={
                                              previousId === val?.id
                                                ? "none"
                                                : "auto"
                                            }
                                            TitleAccountTextSize="font-md"
                                            TitleAccountFontWeight="normal"
                                            SubTitleNameColour="text-secondary"
                                            SubTitleAccountTextSize="font-xs"
                                            SubTitleAccountFontWeight="normal"
                                            RightDivIcon={ICONS?.VIEW_DETAILS}
                                            FirstDivIcon={val?.ifsc_code}
                                            viewdetailsData={() => {
                                              detailNavigate(val?.id);
                                            }}
                                            bankLogo={true}
                                          />
                                        </div>
                                      );
                                    }
                                  })}
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="mt-margin-md">
                            <p className="text-text-primary text-font-sm font-semibold">
                              No active associated accounts found
                            </p>
                            <p className="text-text-secondary text-font-xs font-normal">
                              There are no existing active accounts that are
                              associated with the PAN provided.
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              verifiedPan !== false && (
                <>
                  <div className="w-full flex items-center m-auto justify-center py-padding-xl">
                    <Loader />
                  </div>
                </>
              )
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AssociateAccountEdit;
